// extracted by mini-css-extract-plugin
export default {"tryAgain":"J_cm","result":"J_cn"};